import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type ResetUserPasswordResponseType = {};

export const useResetUserPassword = (
  options?: MutationOptions<
    ResetUserPasswordResponseType,
    string,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (email) => {
      const { data } = await api.post<
        ApiResponse<ResetUserPasswordResponseType>
      >('/auth/send-password-reset-link', {
        email,
      });

      return data.data;
    },
    ...options,
  });
